export default "__VITE_ASSET__Bf9IoS8U__"